import { default as LeaderBoard } from './LeaderBoard';

export default LeaderBoard;
